/* Icons — simple stroked SVGs to match Otto aesthetic */
export function Icon({ name, size = 16, color = 'currentColor', strokeWidth = 1.8, style = {} }) {
  const s = size;
  const sw = strokeWidth;
  const common = { width: s, height: s, viewBox: '0 0 24 24', fill: 'none', stroke: color, strokeWidth: sw, strokeLinecap: 'round', strokeLinejoin: 'round', style };
  switch (name) {
    case 'upload':
      return <svg {...common}><path d="M12 15V4M12 4l-4 4M12 4l4 4M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/></svg>;
    case 'file':
      return <svg {...common}><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/></svg>;
    case 'check':
      return <svg {...common}><path d="M5 12.5l4 4L19 7"/></svg>;
    case 'play':
      return <svg {...common} fill={color} stroke="none"><path d="M6 4l14 8-14 8V4z"/></svg>;
    case 'download':
      return <svg {...common}><path d="M12 4v12M12 16l-4-4M12 16l4-4M4 20h16"/></svg>;
    case 'spark':
      return <svg {...common}><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1"/></svg>;
    case 'spin':
      return <svg {...common}><path d="M12 3a9 9 0 1 1-6.4 2.6"/></svg>;
    case 'table':
      return <svg {...common}><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 10h18M9 5v14"/></svg>;
    case 'warn':
      return <svg {...common}><path d="M12 3L2 20h20L12 3z"/><path d="M12 10v5M12 18v.01"/></svg>;
    case 'print':
      return <svg {...common}><path d="M6 9V3h12v6M6 18H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="7" rx="1"/></svg>;
    case 'sheet':
      return <svg {...common}><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M4 9h16M4 14h16M10 4v16"/></svg>;
    case 'chat':
      return <svg {...common}><path d="M21 15a2 2 0 0 1-2 2H8l-5 4V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
    case 'code':
      return <svg {...common}><path d="M8 8l-4 4 4 4M16 8l4 4-4 4M14 4l-4 16"/></svg>;
    case 'x':
      return <svg {...common}><path d="M6 6l12 12M18 6L6 18"/></svg>;
    case 'arrow-right':
      return <svg {...common}><path d="M5 12h14M13 6l6 6-6 6"/></svg>;
    case 'clock':
      return <svg {...common}><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>;
    case 'info':
      return <svg {...common}><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8v.01"/></svg>;
    default: return null;
  }
}
